import { DefineComponent, FunctionalComponent } from "vue";
import { Key } from "../../types/skyward/svg";
import Svg from "../core/svg";

type ButtonProps =
{
    svgName: Key;
    spanClasses?: string[];
    title?: string;
    disabled?: boolean;
    svgClasses?: string[];
    svgColor?: string;
    svgOnRight?:boolean;
    clickFunc?: (e: MouseEvent) => void;
    onMouseover?: (e: MouseEvent) => void;
    onMouseout?: (e: MouseEvent) => void;
};

const Button: FunctionalComponent<ButtonProps> = function vButton(props: ButtonProps, context)
{
    const span = context.slots.default && <span class={["anchorText", props.svgOnRight ? "textBefore" : "textAfter", "buttonText", ...(props.spanClasses ?? [])]}>{context.slots.default()}</span>;
    return (
        <a role="button" onClick={checkDoOnClick} class={{ button: true, chromeless: true, svgAnchor: true, "ui-disabled": props.disabled === true }} href="javascript:void(0)" title={props.title} {...context.attrs}>
            {props.svgOnRight ? span : null }
            <Svg name={props.svgName}
                svgClasses={[props.svgOnRight ? "svgTextBefore" : "svgTextAfter", "buttonSvg", ...(props.svgClasses ?? [])]}
                tabindex="-1"
                onMouseover={props.onMouseover}
                onMouseout={props.onMouseout}
                style={props.svgColor ? `fill:${props.svgColor};` : ""} />
            {props.svgOnRight ? null : span}
        </a>
    );

    function checkDoOnClick(e: MouseEvent)
    {
        if (props.disabled)
        {
            return;
        }

        props.clickFunc?.(e);
    }
};

Button.props = ["svgName", "spanClasses", "title", "disabled", "svgClasses", "svgColor", "svgOnRight", "clickFunc" ];
export default Button as unknown as DefineComponent<ButtonProps, JSX.Element>;
